<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div v-else>
      <div class="row">
        <div class="form-group">
          <h3>Regras para definição dinâmica de grupo</h3>
          <ol v-if="step.name" class="breadcrumb">
            <li>{{step.workflow.name}}</li>
            <li>{{step.name}}</li>
            <li>{{step.target.description}}</li>
          </ol>
          <br>
          <div class="panel panel-default">
            <div class="panel-body">
              <div v-if="rules.length === 0" class="alert alert-info">Nenhuma regra de redirecionamento</div>
              <div v-for="(rule, index) in rules" class="row">
                <div class="col-sm-2">
                  <label>Operação</label>
                  <select class="form-control" v-model="rule.operation">
                    <option v-for="opt in fieldRules">{{opt}}</option>
                  </select>
                </div>
                <div class="col-sm-3">
                  <label>Nome do Campo</label>
                  <input class="form-control" v-model="rule.fieldName">
                </div>
                <div class="col-sm-2">
                  <label>Argumento</label>
                  <input class="form-control" v-model="rule.argument">
                </div>
                <div class="col-sm-3">
                  <label>Grupo Alvo</label>
                  <multiselect v-model="rule.target" label="description" track-by="objectId" :options="subGroups" :showLabels=false placeholder="Selecione uma opção"></multiselect>
                </div>
                <div class="col-sm-2">
                  <label>Ações</label>
                  <button class="btn btn-sm form-control btn-danger" @click="rules.splice(index, 1)">Remover</button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-sm btn-default pull-right" @click="rules.push({})">Adicionar</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <button class="btn btn-primary" @click="save">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self = {}
import { Parse, miniToastr } from '../Global'
import Loader from './util/Loader'
import Multiselect from 'vue-multiselect'
import { handleParseError } from './util/ErrorHandling'
var Step = Parse.Object.extend('Step')
var StepGroupRule = Parse.Object.extend('StepGroupRule')
const ADMIN_WORKFLOW = 'ADMIN_WORKFLOW'

export default {
  components: {
    Multiselect,
    Loader
  },
  data () {
    return {
      step: {},
      stepParse: {},
      rules: [],
      loading: false,
      fieldRules: ['equals'],
      subGroups: []
    }
  },
  mounted () {
    self = this
    let stepId = self.$route.params.stepId
    self.load(stepId)
  },
  methods: {
    load (stepId) {
      let stepQuery = new Parse.Query(Step)
      stepQuery.include('target')
      stepQuery.include('workflow')
      stepQuery.get(stepId).then(step => {
        self.step = step.toJSON()
        self.stepParse = step
        let querySubGroups = step.get('target').relation('roles').query()
        return querySubGroups.find()
      }).then(subGroups => {
        self.subGroups = subGroups.map(g => g.toJSON())
        let queryRules = new Parse.Query(StepGroupRule)
        let stepParse = new Step()
        stepParse.id = self.step.objectId
        queryRules.equalTo('step', stepParse)
        return queryRules.find()
      }).then(roles => {
        self.rules = roles.map(r => r.toJSON())
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    save () {
      let fieldRulesParse = self.rules.map(ruleJson => {
        let stepGroupRuleParse = new StepGroupRule()
        let targetGroup = new Parse.Role()
        targetGroup.id = ruleJson.target.objectId
        let fieldKeys = ['operation', 'fieldName', 'argument']
        fieldKeys.forEach(f => {
          stepGroupRuleParse.set(f, ruleJson[f])
        })
        stepGroupRuleParse.set('target', targetGroup)
        stepGroupRuleParse.set('step', self.stepParse)
        let acl = new Parse.ACL()
        acl.setRoleWriteAccess(ADMIN_WORKFLOW, true)
        acl.setRoleReadAccess(ADMIN_WORKFLOW, true)
        stepGroupRuleParse.setACL(acl)
        return stepGroupRuleParse
      })
      let rulesToBeDeletedQuery = new Parse.Query(StepGroupRule)
      rulesToBeDeletedQuery.equalTo('step', self.stepParse)
      rulesToBeDeletedQuery.find().then(rulesToBeDeleted => {
        return Parse.Object.destroyAll(rulesToBeDeleted)
      }).then(() => {
        return Parse.Object.saveAll(fieldRulesParse)
      }).then(() => {
        miniToastr.success('Informações salvas')
        self.$router.go(-1)
      }, (error) => {
        self.loading = false
        handleParseError(self, error)
      })
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// StepGroupRuleList.vue?4b867724